import { BrowserCacheLocation } from '@azure/msal-browser';
import { IAuthConfig } from '../auth.types';
import { loggerCallback } from '../logger/logger';

export const ibmec: IAuthConfig[] = [
  {
    envs: ['local'],
    brands: ['ibmec'],
    config: {
      type: 'msal',
      dados: {
        auth: {
          clientId: 'cdb8e5e5-8afc-4784-9194-ddfda450c047',
          authority: 'https://login.dev.ibmec.br/ibmecdev.onmicrosoft.com/B2C_1_signin_sava_candidatos',
          knownAuthorities: ['login.dev.ibmec.br'],
          redirectUri: `${window.location.protocol}//${window.location.host}`,
        },
        cache: {
          cacheLocation: BrowserCacheLocation.LocalStorage,
          storeAuthStateInCookie: false,
        },
        system: {
          loggerOptions: {
            loggerCallback,
          },
        },
        authoritySignUp: 'https://login.dev.ibmec.br/ibmecdev.onmicrosoft.com/B2C_1_signup_sava_candidatos',
        scope: 'https://ibmecdev.onmicrosoft.com/cdb8e5e5-8afc-4784-9194-ddfda450c047/user.read',
      },
      extraQueryParameters: {
        marca: 'ibmec',
        codigo_grupo_marca: '3',
        grupo_marca_label: 'ibmec',
        base_origin: 'https://candidatos.dev.portal.ibmec.br',
      },
    },
    applicationUrl: 'http://localhost:3002',
  },
  {
    envs: ['local'],
    brands: ['ibmec'],
    config: {
      type: 'msal',
      dados: {
        auth: {
          clientId: '2a5466b3-c43a-4cae-be24-5e7fa3b75a91',
          authority: 'https://login.dev.ibmec.br/ibmecdev.onmicrosoft.com/B2C_1_signin',
          knownAuthorities: ['login.dev.ibmec.br'],
          redirectUri: `${window.location.protocol}//${window.location.host}`,
        },
        cache: {
          cacheLocation: BrowserCacheLocation.LocalStorage,
          storeAuthStateInCookie: false,
        },
        system: {
          loggerOptions: {
            loggerCallback,
          },
        },
        authoritySignUp: 'https://login.dev.ibmec.br/ibmecdev.onmicrosoft.com/B2C_1_signup',
        scope: 'https://ibmecdev.onmicrosoft.com/2a5466b3-c43a-4cae-be24-5e7fa3b75a91/user.read',
      },
      extraQueryParameters: {
        marca: 'ibmec',
        codigo_grupo_marca: '3',
        grupo_marca_label: 'ibmec',
        base_origin: 'https://candidatos.dev.portal.ibmec.br',
      },
    },
    applicationUrl: 'http://localhost:3006',
  },
  {
    envs: ['dev'],
    brands: ['ibmec'],
    config: {
      type: 'msal',
      dados: {
        auth: {
          clientId: 'cdb8e5e5-8afc-4784-9194-ddfda450c047',
          authority: 'https://login.dev.ibmec.br/ibmecdev.onmicrosoft.com/B2C_1_signin_sava_candidatos',
          knownAuthorities: ['login.dev.ibmec.br'],
          redirectUri: `${window.location.protocol}//${window.location.host}`,
        },
        cache: {
          cacheLocation: BrowserCacheLocation.LocalStorage,
          storeAuthStateInCookie: false,
        },
        system: {
          loggerOptions: {
            loggerCallback,
          },
        },
        authoritySignUp: 'https://login.dev.ibmec.br/ibmecdev.onmicrosoft.com/B2C_1_signup_sava_candidatos',
        scope: 'https://ibmecdev.onmicrosoft.com/cdb8e5e5-8afc-4784-9194-ddfda450c047/user.read',
      },
      extraQueryParameters: {
        marca: 'ibmec',
        codigo_grupo_marca: '3',
        grupo_marca_label: 'ibmec',
        base_origin: 'https://candidatos.dev.portal.ibmec.br',
      },
    },
    applicationUrl: 'https://candidato.ibmec.sava.dev.yduqs.com.br',
  },
  {
    envs: ['dev'],
    brands: ['ibmec'],
    config: {
      type: 'msal',
      dados: {
        auth: {
          clientId: '2a5466b3-c43a-4cae-be24-5e7fa3b75a91',
          authority: 'https://login.dev.ibmec.br/ibmecdev.onmicrosoft.com/B2C_1_signin',
          knownAuthorities: ['login.dev.ibmec.br'],
          redirectUri: `${window.location.protocol}//${window.location.host}`,
        },
        cache: {
          cacheLocation: BrowserCacheLocation.LocalStorage,
          storeAuthStateInCookie: false,
        },
        system: {
          loggerOptions: {
            loggerCallback,
          },
        },
        authoritySignUp: 'https://login.dev.ibmec.br/ibmecdev.onmicrosoft.com/B2C_1_signup',
        scope: 'https://ibmecdev.onmicrosoft.com/2a5466b3-c43a-4cae-be24-5e7fa3b75a91/user.read',
      },
      extraQueryParameters: {
        marca: 'ibmec',
        codigo_grupo_marca: '3',
        grupo_marca_label: 'ibmec',
        base_origin: 'https://candidatos.dev.portal.ibmec.br',
      },
    },
    applicationUrl: 'https://experimente.dev.ibmec.br',
  },
  {
    envs: ['qld'],
    brands: ['ibmec'],
    config: {
      type: 'msal',
      dados: {
        auth: {
          clientId: '201b732f-6414-49f9-bf61-721e90f0a7cd',
          authority: 'https://login.qa.ibmec.br/ibmecqas.onmicrosoft.com/B2C_1_signin_sava_candidatos',
          knownAuthorities: ['login.qa.ibmec.br'],
          redirectUri: `${window.location.protocol}//${window.location.host}`,
        },
        cache: {
          cacheLocation: BrowserCacheLocation.LocalStorage,
          storeAuthStateInCookie: false,
        },
        system: {
          loggerOptions: {
            loggerCallback,
          },
        },
        authoritySignUp: 'https://login.qa.ibmec.br/ibmecqas.onmicrosoft.com/B2C_1_signup_sava_candidatos',
        scope: 'https://ibmecqas.onmicrosoft.com/201b732f-6414-49f9-bf61-721e90f0a7cd/user.read',
      },
      extraQueryParameters: {
        marca: 'ibmec',
        codigo_grupo_marca: '3',
        grupo_marca_label: 'ibmec',
        base_origin: 'https://candidatos.qa.portal.ibmec.br',
      },
    },
    applicationUrl: 'https://candidato.ibmec.sava.qld.yduqs.com.br',
  },
  {
    envs: ['qld'],
    brands: ['ibmec'],
    config: {
      type: 'msal',
      dados: {
        auth: {
          clientId: '603ca90b-a944-462f-8552-e92d004f8d63',
          authority: 'https://login.qa.ibmec.br/ibmecqas.onmicrosoft.com/B2C_1_signin',
          knownAuthorities: ['login.qa.ibmec.br'],
          redirectUri: `${window.location.protocol}//${window.location.host}`,
        },
        cache: {
          cacheLocation: BrowserCacheLocation.LocalStorage,
          storeAuthStateInCookie: false,
        },
        system: {
          loggerOptions: {
            loggerCallback,
          },
        },
        authoritySignUp: 'https://login.qa.ibmec.br/ibmecqas.onmicrosoft.com/B2C_1_signup',
        scope: 'https://ibmecqas.onmicrosoft.com/603ca90b-a944-462f-8552-e92d004f8d63/user.read',
      },
      extraQueryParameters: {
        marca: 'ibmec',
        codigo_grupo_marca: '3',
        grupo_marca_label: 'ibmec',
        base_origin: 'https://candidatos.qa.portal.ibmec.br',
      },
    },
    applicationUrl: 'https://experimente.qa.ibmec.br',
  },
  {
    envs: ['prd'],
    brands: ['ibmec'],
    config: {
      type: 'msal',
      dados: {
        auth: {
          clientId: '370c3901-2de5-4fdb-8bdc-0e6d4706be60',
          authority: 'https://login.ibmec.br/loginibmec.onmicrosoft.com/B2C_1_signin_sava_candidatos',
          knownAuthorities: ['login.ibmec.br'],
          redirectUri: `${window.location.protocol}//${window.location.host}`,
        },
        cache: {
          cacheLocation: BrowserCacheLocation.LocalStorage,
          storeAuthStateInCookie: false,
        },
        system: {
          loggerOptions: {
            loggerCallback,
          },
        },
        authoritySignUp: 'https://login.ibmec.br/loginibmec.onmicrosoft.com/B2C_1_signup_sava_candidatos',
        scope: 'https://loginibmec.onmicrosoft.com/370c3901-2de5-4fdb-8bdc-0e6d4706be60/user.read',
      },
      extraQueryParameters: {
        marca: 'ibmec',
        codigo_grupo_marca: '3',
        grupo_marca_label: 'ibmec',
        base_origin: 'https://candidatos.portal.ibmec.br',
      },
    },
    applicationUrl: 'https://candidatos.sava.ibmec.br',
  },
  {
    envs: ['prd'],
    brands: ['ibmec'],
    config: {
      type: 'msal',
      dados: {
        auth: {
          clientId: '6ef86832-de7b-4415-8c76-dd8d41f801cd',
          authority: 'https://login.ibmec.br/loginibmec.onmicrosoft.com/B2C_1_signin',
          knownAuthorities: ['login.ibmec.br'],
          redirectUri: `${window.location.protocol}//${window.location.host}`,
        },
        cache: {
          cacheLocation: BrowserCacheLocation.LocalStorage,
          storeAuthStateInCookie: false,
        },
        system: {
          loggerOptions: {
            loggerCallback,
          },
        },
        authoritySignUp: 'https://login.ibmec.br/loginibmec.onmicrosoft.com/B2C_1_signup',
        scope: 'https://loginibmec.onmicrosoft.com/6ef86832-de7b-4415-8c76-dd8d41f801cd/user.read',
      },
      extraQueryParameters: {
        marca: 'ibmec',
        codigo_grupo_marca: '3',
        grupo_marca_label: 'ibmec',
        base_origin: 'https://candidatos.portal.ibmec.br',
      },
    },
    applicationUrl: 'https://experimente.ibmec.br',
  },
];
